import axios from "axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import Cookies from "js-cookie";

import { getBaseUrl } from "../../service/apiUrl";
export const STATUSES = Object.freeze({
    IDLE: 'idle',
    ERROR: 'error',
    LOADING: 'loading',
});

const getHorsemodalstatsSlice = createSlice({
    name: 'horsemodalstats',
    initialState: {
        data: [],
        status: STATUSES.IDLE,
    },

    extraReducers: (builder) => {
        builder
            .addCase(fetchHorsemodalstats.pending, (state, action) => {
                state.status = STATUSES.LOADING;
            })
            .addCase(fetchHorsemodalstats.fulfilled, (state, action) => {
                state.data = action.payload;
                state.status = STATUSES.IDLE;
            })
            .addCase(fetchHorsemodalstats.rejected, (state, action) => {
                state.status = STATUSES.ERROR;
            });
    }
});

export const { setTrainer, setStatus } = getHorsemodalstatsSlice.actions;
export default getHorsemodalstatsSlice.reducer;

export const fetchHorsemodalstats = createAsyncThunk('/HorsemodalForStatisitics/fetch', async ({ id } = {}) => {
    const cleanId = id?._id || id?.id || (typeof id === 'string' ? id : "");
    if (!cleanId) return {};
    const token = Cookies.get("token");
    const baseUrl = getBaseUrl().replace(/\/+$/, "");
    const headers = {};
    if (token && token !== "undefined") {
        headers.Authorization = token;
        headers["x-xsrf-token"] = token;
    }
    const res = await axios.get(`${baseUrl}/HorseStatsModal/${cleanId}`, {
        headers
    });
    const trainerstatsData = res.data;
    return trainerstatsData;
});
